import {
  INIT_REDUCER,
  CLEAR_ERRORS,
  CREATE_ERRORS,
  GET_CEMEX_TRACKING_ORDERS_REQUEST,
} from './types';

const getCemexTrackingOrders = (payload) => ({
  type: GET_CEMEX_TRACKING_ORDERS_REQUEST,
  payload,
});

const initReducer = () => ({
  type: INIT_REDUCER,
});

const clearErrors = () => ({
  type: CLEAR_ERRORS,
});

const createErrors = (payload) => ({
  type: CREATE_ERRORS,
  payload: payload,
});

export { getCemexTrackingOrders, initReducer, clearErrors, createErrors };
